import client from '@util/api'
import { PATIENTS } from '../../../route.const'
import { ProviderDetails } from '@provider/context/ProviderProfileProvider/typing'
import {
  ISaveActions,
  ICallbackRequest,
  ICallToFeedbackRequest,
} from '@patient/SearchResult/typings'

export interface OrganizationValidationResponse {
  valid: boolean
  id: string
  name: string
}

export const saveCallbackInfo = async (request: ICallbackRequest) => {
  const { data } = await client.post(`/${PATIENTS}/request-callback`, request)
  return data
}
export const saveCalltoschdFeedbackInfo = async (
  request: ICallToFeedbackRequest
) => {
  const { data } = await client.post(
    `/${PATIENTS}/calltoschd_feedback`,
    request
  )
  return data
}
export const providerDetails = async (id: string, activeSurveyId: string) => {
  const response = await client.get<ProviderDetails>(
    `/${PATIENTS}/search/provider/${id}?survey_id=${activeSurveyId}`
  )
  return response.data
}

export const saveActions = async (request: ISaveActions) => {
  const { data } = await client.patch(`/${PATIENTS}/actions`, request)
  return data
}

export const saveOrganizations = async (organizationId: string) => {
  const { data } = await client.post(`/${PATIENTS}/set-referred-by`, {
    organization: organizationId,
  })
  return data
}

/**
 * Validate an organization ID from URL referral
 * Public endpoint - no authentication required
 *
 * @param orgId - Organization ID to validate
 * @returns Organization info if valid, throws error if not found
 */
export const validateOrganization = async (
  orgId: string
): Promise<OrganizationValidationResponse> => {
  const { data } = await client.get<OrganizationValidationResponse>(
    `/${PATIENTS}/organizations/${orgId}/validate`
  )
  return data
}
